module.exports = __webpack_public_path__ + "static/media/grand-pere-jean-sponsor.d44d82d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grand-pere-jean-sponsor.png
// module id = 2502
// module chunks = 0